(function(){
    'use strict';

    angular
       .module('appback')
       .factory('GenerallabService', GenerallabService);

   GenerallabService.$inject = ['$http'];

   function GenerallabService($http){

       var service = {
          trackings: {},
           optionsSelect2 : { 
               ajax: {
                   url: "/backend/altcrm/content/select2",
                   dataType: 'json',
                   delay: 250,
                   data: function (params) {
                     return {
                       q: params.term, // search term
                       page: params.page,
                       field: 'nombre',
                       per_page: 20,
                       //nodetype:'microorganismo'
                     };
                   },
                   processResults: function (data, params) {
                     params.page = params.page || 1;
                     return {
                       results: data.items,
                       pagination: {
                         more: (params.page * 1) < data.total_count
                       }
                     };
                   },
                   cache: true
               }
           },
           optionsCuentaUlab : {
            //data:[{id: "0003", text: "1"}],
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/ulab/getcuentasulab",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: 1,
                      lang_code:"es",
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
                
            },
            
        },
       };

       return service;
        

   }
})();